import React from "react";
import { Select } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { PRICE_TYPES, PRICE_TYPES_OPTION } from "./variables";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE } from "utils/constants";

const { Option } = Select;

const useStyles = makeStyles({
  root: { width: "250px!important" },

  filtersContainer: {
    display: "flex",
    alignItems: "center",
    height: 60,
    overflow: "auto",

    "@media (max-width: 576px)": {
      height: "auto",
      flexDirection: "column",
      width: "100%",
      overflow: "hidden",
      gap: 10,
      alignItems: "start",
    },

    "& .ant-select-selection-overflow": {
      flexWrap: "nowrap",
    },
    "&> span": {
      color: "#666666",
      fontSize: 13,
      fontWeight: 300,
    },
  },
  value: {
    width: "auto !important",
  },
  range: {
    width: "100px!important",
  },
});

const PriceTypeFilter = ({ onTypeChange }) => {
  const classes = useStyles();
  const { filters } = useStoreFilters(FILTER_PAGE.PRICES);

  return (
    <>
      <div className="custom-filter">
        <div className={classes.filtersContainer}>
          <span>Price Type:</span>
          <Select
            defaultValue={filters?.type || PRICE_TYPES_OPTION.DEFAULT}
            onChange={onTypeChange}
            size="default"
            placeholder="Select price type"
          >
            {PRICE_TYPES.map(item => (
              <Option key={`${item}-option`} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    </>
  );
};

export default PriceTypeFilter;
